// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import { withTheme } from 'styled-components';

import Theme from 'statsradio/themes';
import GenderPie from 'common/components/ui/charts/GenderPie';
import { type ReachByGender } from '../../../domain/DashboardData';
import { DemographyPercent, DemographyPercentRow } from './DemographyPercentLayout';

interface Props {
  metrics: ReachByGender;

  t: (key: string) => string;
  theme: typeof Theme;
}

function DashboardGenderCard({ metrics, t, theme }: Props) {
  const male = metrics.male / (metrics.male + metrics.female);
  const female = metrics.female / (metrics.male + metrics.female);

  return (
    <React.Fragment>
      <GenderPie
        male={male}
        female={female}
        height={200}
      />
      <DemographyPercentRow>
        <DemographyPercent
          label={t('gender.women')}
          percent={female}
          color={theme.V3.colors.female}
        />
        <DemographyPercent
          label={t('gender.men')}
          percent={male}
          color={theme.V3.colors.male}
        />
      </DemographyPercentRow>
    </React.Fragment>
  );
}

export default translate('dashboard')(withTheme(DashboardGenderCard));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/demography/DashboardGenderCard.js